<!-- div class="mat-card mat-elevation-z2 p-24" fxLayout="column" -->
<!-- div fxLayout="row" fxLayoutAlign="space-between center">
        <div class="h1 pr-16">Clientes</div>
    </div -->
<!-- mat-form-field>
        <span matPrefix>
            <mat-icon>search</mat-icon>
        </span>
        <input matInput #filter placeholder="Buscar..." />
    </mat-form-field -->
    
<div class="contenedor-tabla">
    <mat-table
        class="clientes-tabla"
        #table
        [dataSource]="dataSource"
        matSort
        matSortActive="nrRut"
        matSortDisableClear
        matSortDirection="desc"
        [@animateStagger]="{ value: '50' }"
        fusePerfectScrollbar
    >
        <ng-container matColumnDef="nombre">
            <mat-header-cell *matHeaderCellDef mat-sort-header
                >Nombre</mat-header-cell
            >
            <mat-cell *matCellDef="let cliente">
                <a [routerLink]="'/clientes/' + cliente.id" [state]="cliente">
                    {{ cliente.nombre }}
                </a>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="nrrut">
            <mat-header-cell *matHeaderCellDef mat-sort-header
                >Rut</mat-header-cell
            >
            <mat-cell *matCellDef="let cliente">
                <p>
                    {{ cliente.rut }}
                </p>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="fechainicio">
            <mat-header-cell *matHeaderCellDef mat-sort-header
                >Desde</mat-header-cell
            >
            <mat-cell *matCellDef="let cliente">
                <p>
                    {{ cliente.fechaInicio | date: "dd-MM-yyyy HH:mm:ss" }}
                </p>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="activo">
            <mat-header-cell *matHeaderCellDef>Estado</mat-header-cell>
            <mat-cell *matCellDef="let cliente">
                <span *ngIf="!cliente.fechaTermino" class="green-600 s-16 p-4"
                    >Activo</span
                >
                <span *ngIf="cliente.fechaTermino" class="red-500 s-16 p-4"
                    >Inactivo</span
                >
            </mat-cell>
        </ng-container>

        <mat-header-row
            *matHeaderRowDef="displayedColumns; sticky: true"
        ></mat-header-row>

        <mat-row *matRowDef="let cliente; columns: displayedColumns"> </mat-row>
    </mat-table>
    <mat-paginator
        #paginator
        [length]="resultsLength"
        [pageIndex]="0"
        [pageSize]="10"
        [pageSizeOptions]="[1, 5, 10, 25, 100]"
    >
    </mat-paginator>
</div>
<!-- /div -->
